import script from "./IdentityMark.vue?vue&type=script&setup=true&lang=js"
export * from "./IdentityMark.vue?vue&type=script&setup=true&lang=js"

import "./IdentityMark.vue?vue&type=style&index=0&id=3580e251&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3580e251"]])

export default __exports__